import { render, staticRenderFns } from "./industryEdition.vue?vue&type=template&id=4b304072&scoped=true&"
import script from "./industryEdition.vue?vue&type=script&lang=js&"
export * from "./industryEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b304072",
  null
  
)

export default component.exports